import { render, staticRenderFns } from "./middlelogin.vue?vue&type=template&id=6881fa20&scoped=true&"
import script from "./middlelogin.vue?vue&type=script&lang=js&"
export * from "./middlelogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6881fa20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6881fa20')) {
      api.createRecord('6881fa20', component.options)
    } else {
      api.reload('6881fa20', component.options)
    }
    module.hot.accept("./middlelogin.vue?vue&type=template&id=6881fa20&scoped=true&", function () {
      api.rerender('6881fa20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/middlelogin.vue"
export default component.exports